import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { colors } from "../../utils/colors";
import { Transaction } from "../../utils/types";
import { BsThreeDotsVertical } from "react-icons/bs";
import { subDays, format } from "date-fns";
import { helpers } from "../../utils/helpers";

export const Transactions = () => {
    const getLatestsTransactions = () => {
        const date = new Date();
        const allTrans: Transaction[] = [];

        for (let i = 0; i < 10; i++) {
            const type: "Debit" | "Deposit" = helpers.RandomNumber(1, 10) % 2 === 0 ? "Debit" : "Deposit";
            const day = format(subDays(date, i), "MM/dd/yy");
            const id = `${helpers.RandomNumber(1000, 9999)}-${helpers.RandomNumber(100, 999)}-${helpers.RandomNumber(
                1000,
                9999
            )}`;

            const trans: Transaction = {
                date: day,
                description: `${type.toUpperCase()} UberEats #${id}`,
                type: type,
                amount: "$35.83",
                availableBalance: "$25,000.00",
                transactionId: id
            };

            allTrans.push(trans);
        }

        return allTrans;
    };
    const transactions: Transaction[] = getLatestsTransactions();

    return (
        <div className="transaction-container">
            <h1 style={{ padding: "20px 0" }}>Transactions</h1>

            <TableContainer component={Paper} sx={{ overflowY: "scroll" }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow sx={{ borderBottom: "1px solid black" }}>
                            <TableCell style={{ minWidth: 100 }}>
                                <h4>Processing Date</h4>
                            </TableCell>
                            <TableCell align="left" sx={{ minWidth: 170 }}>
                                <h4>Description</h4>
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: 20 }}>
                                <h4>Type</h4>
                            </TableCell>
                            <TableCell align="right" sx={{ minWidth: 100 }}>
                                <h4>Amount</h4>
                            </TableCell>
                            <TableCell align="right" sx={{ minWidth: 100 }}>
                                <h4>Available Balance</h4>
                            </TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{}}>
                        {transactions.map((x, i) => {
                            return (
                                <TableRow
                                    key={`table-row-${i}`}
                                    sx={{
                                        border: 0,

                                        backgroundColor: i % 2 === 1 ? colors.offWhite : "white"
                                    }}
                                >
                                    <TableCell component="th" scope="row">
                                        {x.date}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        {x.description}
                                    </TableCell>

                                    <TableCell align="center" sx={{}}>
                                        {x.type}
                                    </TableCell>

                                    <TableCell align="right" sx={{}}>
                                        {x.amount}
                                    </TableCell>
                                    <TableCell align="right" sx={{}}>
                                        {x.availableBalance}
                                    </TableCell>
                                    <TableCell align="right">
                                        <button className="transaction-icon">
                                            <BsThreeDotsVertical size={20} />
                                        </button>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};
